/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */



import Store from "./store";
import map from "fj-map";
import compose from "fj-compose";
import pluck from "fj-pluck";
var getWho = pluck("who");

import * as Sentry from "@sentry/react";

export default UserAllStore;

function UserAllStore(api, events) {
	var store = new Store();

	api.org.group.current.data()
		.then(pluck("_id"))
		.then(listen_for_changes)
		.catch(error => {
			Sentry.captureException(error);
			console.error.bind(console, error);
		});

	var query = "";
	var status = "";

	store.search = search;
	store.searchStatus = searchStatus;

	reset();

	return store;

	function reset() {
		store.clear();
		return api.org.users
			.list(query, null, status)
			.then(map(add_person));
	}

	function search(newQuery) {
		query = newQuery;
		return reset();
	}

	// Does a search on a user's status ie. active/inactive.  Null or empty string
	// argument applies no filter
	function searchStatus(newStatus) {
		status = newStatus;
		return reset();
	}

	function add_person(id) {
		store.set(id, id);
	}

	function remove_person(id) {
		store.remove(id);
	}

	function listen_for_changes(group) {
		events.on("mqtt:orggroup/" + group + "/users/added", compose(add_person, getWho));
		events.on("mqtt:orggroup/" + group + "/users/removed", compose(remove_person, getWho));
	}
}